<template>
  <div v-if="adCampaign">
    <div class="vx-col w-full">
      <div class="bi-campaign--info-box">
        <h3 class="mb-5">Stellenvergleich</h3>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <VacancyCompareChart
              :numbers="vacancies.map(el => el.number)"
              metric="VISITORS"
              header="Besucher der letzten Woche"
              :source-ids="[
                'e9658681-1253-49c1-a707-c8db6d565f38' //google
              ]"
              class="mb-5"
            />
          </div>
          <div class="vx-col w-full lg:w-1/2">
            <VacancyCompareChart
              :numbers="vacancies.map(el => el.number)"
              metric="APPLICATIONS_SENT"
              header="Bewerbungen der letzten Woche"
              :source-ids="[
                'e9658681-1253-49c1-a707-c8db6d565f38' //google
              ]"
              class="mb-5"
              @chartDataSet="
                values =>
                  $emit(
                    'applicantNumberSet',
                    values.reduce(
                      (accumulator, currentValue) => accumulator + currentValue
                    )
                  )
              "
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-for="googleAd of adCampaign.googleAds"
      :key="googleAd.id"
      class="bi-campaign--info-box"
    >
      <h3>
        {{ googleAd.adGroupName }} <br /><small style="font-weight:300">{{
          googleAd.customerName
        }}</small>
      </h3>
      <p class="mb-3">
        Kampagne für:
        <a :href="googleAd.finalURLs" target="_blank">{{
          googleAd.finalURLs
        }}</a>
      </p>
      <table class="important-informations mb-8">
        <thead>
          <tr>
            <th>Klicks</th>
            <th>Impressionen</th>
            <th>CTR</th>
            <th>CPC</th>
            <th>Conversions</th>
            <th>Kosten</th>
            <th>Start</th>
            <th>Ende</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ googleAd.clicks.toLocaleString() }}</td>
            <td>{{ googleAd.impressions.toLocaleString() }}</td>
            <td>{{ googleAd.ctr.toLocaleString() }}</td>
            <td>
              {{
                (googleAd.avgCpc / 1000000).toLocaleString(undefined, {
                  style: "currency",
                  currency: "EUR"
                })
              }}
            </td>
            <td>{{ googleAd.conversions.toLocaleString() }}</td>
            <td>
              {{
                (googleAd.costMicros / 1000000).toLocaleString(undefined, {
                  style: "currency",
                  currency: "EUR"
                })
              }}
            </td>
            <td>{{ $d(new Date(googleAd.campaignStartDate), "short") }}</td>
            <td>{{ $d(new Date(googleAd.campaignEndDate), "short") }}</td>
          </tr>
        </tbody>
      </table>
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/2">
          <GoogleStat :id="googleAd.id"></GoogleStat>
        </div>
        <div class="vx-col w-full lg:w-1/2">
          <GoogleStatCosts :id="googleAd.id"></GoogleStatCosts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import GoogleStat from "./stats/GoogleStat";
import GoogleStatCosts from "./stats/GoogleStatCosts";
import VacancyCompareChart from "../../stats/VacancyCompareChart";

export default {
  components: {
    GoogleStat,
    GoogleStatCosts,
    VacancyCompareChart
  },
  props: {
    campaignId: { type: String, required: true },
    vacancies: { type: Array, required: true }
  },
  emits: ["applicantNumberSet"],
  data() {
    return {
      datacollection: null
    };
  },
  apollo: {
    adCampaign: {
      query: gql`
        query adCampaign($id: ID!) {
          adCampaign(id: $id) {
            id
            googleAds {
              id
              adName
              adGroupName
              customerName
              campaignStartDate
              campaignEndDate
              headlinePart1
              headlinePart2
              description
              finalURLs
              clicks
              impressions
              ctr
              avgCpc
              costMicros
              conversions
              avgCost
            }
            googleAdGroups {
              id
              adName
              adGroupName
              customerName
              campaignStartDate
              campaignEndDate
              headlinePart1
              headlinePart2
              description
              finalURLs
              clicks
              impressions
              ctr
              avgCpc
              costMicros
              conversions
              avgCost
            }
          }
        }
      `,
      variables() {
        return {
          id: this.campaignId
        };
      }
    }
  }
};
</script>
